"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelKeywordPayloadFields = void 0;
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.ChannelKeywordPayloadFields = {
    channelId: core_1.IdSchema,
    campaignId: core_1.IdSchema,
    campaignName: core_1.NameSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
    userId: core_1.IdSchema,
    userName: core_1.NameSchema,
    keyword: ruby_1.KeywordSchema,
};
